import { useTheme } from '@automata/mui-theme';
import { SVGProps } from 'react';

type Props = SVGProps<SVGLineElement>;

const ViewBorderLine = (props: Props) => {
  const theme = useTheme();
  return <line stroke={theme.palette.grey[500]} strokeWidth={2} {...props} />;
};

export default ViewBorderLine;
